import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { CurrentUserService } from './current-user.service';
import { environment } from '../../../../environments/environment';
import { HeaderHelperService } from '../header-helper.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private http: HttpClient,
    private _currentUserService: CurrentUserService,
    private headerHelperService: HeaderHelperService,
    private router: Router
  ) {}

  login(
    email: string,
    password: string,
    selectedLanguageCode: string
  ): Observable<any> {
    const lang = localStorage.getItem('selectedLanguage') || 'tr';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Content-Language': `${lang}`,
    });
    return this.http
      .post<any>(
        `${environment.apiLocations.identity}/Auth`,
        { email, password, selectedLanguageCode },
        { headers: headers }
      )
      .pipe(
        map((user) => {
          if (user && user.token) {
            this._currentUserService.SetSession(user);
          }
          return user;
        })
      );
  }

  firstLogin(form: any): Observable<any> {
    let url = `${environment.apiLocations.identity}/Auth/first-login`;

    return this.http
      .put<any>(url, form, {
        headers: this.headerHelperService.getHeaders(),
      })
      .pipe(
        map((user) => {
          if (user && user.token) {
            this._currentUserService.SetSession(user);
          }
          return user;
        })
      );
  }

  sendEmailAuthForEnable(): Observable<any> {
    {
      let url = `${environment.apiLocations.identity}/Authenticator/send-email-auth-for-enable`;

      return this.http.get<any>(url, {
        headers: this.headerHelperService.getHeaders(),
      });
    }
  }

  enableEmailAuth(form: any): Observable<any> {
    let url = `${environment.apiLocations.identity}/Authenticator/enable-email-auth`;

    return this.http.put<any>(url, form, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  loginWithMailAuthenticator(data: any): Observable<any> {
    return this.http
      .post<any>(
        `${environment.apiLocations.identity}/Auth/login-with-email-authenticator`,
        data,
        {
          headers: this.headerHelperService.getHeaders(),
        }
      )
      .pipe(
        map((user) => {
          if (user && user.token) {
            this._currentUserService.SetSession(user);
          }
          return user;
        })
      );
  }

  getGoogleAuth(): Observable<any> {
    {
      let url = `${environment.apiLocations.identity}/Authenticator/get-google-auth`;

      return this.http.get<any>(url, {
        headers: this.headerHelperService.getHeaders(),
      });
    }
  }

  enableGoogleAuth(form: any): Observable<any> {
    let url = `${environment.apiLocations.identity}/Authenticator/enable-google-auth`;

    return this.http.put<any>(url, form, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  loginWithGoogleAuthenticator(data: any): Observable<any> {
    return this.http
      .post<any>(
        `${environment.apiLocations.identity}/Auth/login-with-google-authenticator`,
        data,
        {
          headers: this.headerHelperService.getHeaders(),
        }
      )
      .pipe(
        map((user) => {
          if (user && user.token) {
            this._currentUserService.SetSession(user);
          }
          return user;
        })
      );
  }

  forgotPassword(data: any): Observable<any> {
    return this.http.put<any>(
      `${environment.apiLocations.identity}/Auth/forgot-password`,
      data,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }
  resetPassword(data: any): Observable<any> {
    return this.http.put<any>(
      `${environment.apiLocations.identity}/Auth/reset-pasword-with-emailcode`,
      data,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  logout(): Observable<any> {
    const currentUser = this._currentUserService.GetSession();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${currentUser?.token}`,
    });
    return this.http
      .get<any>(`${environment.apiLocations.identity}/Auth/logout`, {
        headers: headers,
      })
      .pipe(
        finalize(() => {
          this._currentUserService.TerminateSession();
          this.deleteAllCookies();
          setTimeout(() => {
            this.router.navigate(['/login']);
          }, 100);
        })
      );
  }

  deleteAllCookies(): void {
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;

      // Cookies deleting while setting past dates
      document.cookie =
        name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    }
  }
}
